import React from 'react';
import { useCommunicationStats } from '../../context/CommunicationStatsContext';
import '../../styles/CommandCenterSidebar.css';

const CommunicationSidebarContent: React.FC = () => {
  const { stats } = useCommunicationStats();

  return (
    <div className="cc-sb-dashboard">
      <div className="cc-sb-stats">
        {[
          { cls: 'cc-sb-stat--purple', lbl: 'IN THIS INBOX', ctx: 'Email + voice, unified', val: stats.inboxCount, numCls: 'cc-sb-stat__num--purple' },
          { cls: 'cc-sb-stat--amber', lbl: 'NEEDS A REPLY', ctx: 'Open and in progress', val: stats.needsReplyCount, numCls: 'cc-sb-stat__num--amber' },
          { cls: 'cc-sb-stat--cyan', lbl: 'RECENT CALLS', ctx: 'Momentum Voice history', val: stats.recentCallsCount, numCls: 'cc-sb-stat__num--cyan' },
        ].map((s, i) => (
          <div key={i} className={`cc-sb-stat ${s.cls}`}>
            <div className="cc-sb-stat__body">
              <span className="cc-sb-stat__label">{s.lbl}</span>
              <span className="cc-sb-stat__context">{s.ctx}</span>
            </div>
            <span className={`cc-sb-stat__num ${s.numCls}`}>{s.val}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunicationSidebarContent;
